import request from '@/utils/request'

/**
 * 任务1：待办红点计数
 * 返回 { approve, pending, rejected }——口径与三个待办页面一致（factory 过滤）
 * 注意：PC request.js baseURL 为空，url 需带 /api 前缀（与 api/menu.js 一致）
 */
export function getTaskCount() {
  return request({ url: '/api/wms/task/count', method: 'get' })
}
